import React, { memo } from 'react';
export function PainPointsSection() {
  const pains = ['🃏 78 cartas te abruman y no sabés cómo memorizarlas.', '🔍 Buscás interpretaciones en internet y terminás más confundida.', '😓 Te da inseguridad leerle a otros por miedo a equivocarte.', '🧩 No sabés qué tirada elegir para cada pregunta.', '🔮 Dudás de tu intuición y sentís que "inventás" las respuestas.', '🤝 Querés cobrar por tus lecturas pero sentís el síndrome del impostor.'];
  return <section className="px-4 py-12 pt-[1px] pb-[1px] pl-[1px] pr-[1px]" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <h2 className="mb-8 font-bold text-center md:text-4xl text-brand-teal text-[20px]" data-id="element-214">
          Si algo de esto te suena, este material fue pensado para vos
        </h2>

        <div className="grid gap-4 md:grid-cols-2" data-id="element-215">
          {pains.map((pain, i) => <div key={i} className="p-5 transition-colors rounded-xl bg-[#1a1a1a] border border-brand-teal/10 hover:bg-brand-tealLight/50" data-id="element-216">
              <p className="text-brand-dark/90 leading-relaxed" data-id="element-217">{pain}</p>
            </div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-218">
          <p className="text-2xl font-serif italic font-medium text-brand-teal" data-id="element-219">
            "No es falta de intuición. Es falta de un método claro y
            estructurado para aprender."
          </p>
        </div>
      </div>
    </section>;
}